import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getQueryStringFromParams } from "../../api/utils/paramUtils";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { DocumentDownloadDTO } from "../../dtos/DocumentDownloadDTO";
import { ValidationDocument } from "../../dtos/ValidationDocumentDto";

export function useDownloadTaxSubmissionSogei() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async ({
            taxSubmissionId,
            type,
        }: {
            taxSubmissionId: string;
            type: ValidationDocument;
        }): Promise<DocumentDownloadDTO> => {
            const queryString = getQueryStringFromParams({
                type: type,
            });
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${taxSubmissionId}/validation?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return {
                content: new Uint8Array(await response.arrayBuffer()),
                type: response.headers.get("content-type") ?? "",
            };
        },
        meta: {
            errorMessage: t("errors.messages.downloadSogei"),
        },
    });

    return mutation;
}
